import * as React from 'react'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { useField } from 'formik'
import { currencyString as formatCurrency } from '@sales-center/common'

interface Props
  extends Omit<
    TextFieldProps,
    'name' | 'value' | 'error' | 'type' | 'onBlur' | 'onChange'
  > {
  name: string
}

export const CurrencyField: React.FC<Props> = (props) => {
  const { name, placeholder = '0.00', helperText: propsHelperText } = props

  const [field, meta, helpers] = useField<string>(name)
  const { onBlur: fieldOnBlur, ...fieldProps } = field
  const { error, touched } = meta
  const { setValue } = helpers

  const hasError = touched && error !== undefined
  const helperText = hasError && !!error ? error : propsHelperText

  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    fieldOnBlur(event)
    setValue(field.value === '' ? field.value : formatCurrency(field.value))
  }

  return (
    <TextField
      {...fieldProps}
      {...props}
      onBlur={onBlur}
      error={hasError}
      helperText={helperText}
      placeholder={placeholder}
    />
  )
}
CurrencyField.displayName = 'CurrencyField'
